import Vue from 'vue';

const success = (context, response) => {
  context.closeModal('#rental-email-modal');
  context.rentalBookingComConfigs.hotelId =  context.rental.booking_hotel_id = response.data.hotelId;
  context.rentalBookingComConfigs.roomCode = context.rental.booking_room_id = response.data.roomId;
  context.rentalBookingComConfigs.rateCode = context.rental.booking_rate_id = response.data.rateId;
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  toastr.success(context.$t('rentals.detail.update_success'));
  context.smallLoading = false;
  if (context.rental.booking_room_id && context.rental.booking_hotel_id && context.rental.booking_rate_id) {
    context.openModal('#sync-in-progress-modal');
  }
  context.fetch_rental(context.rental.id);
};

const failed = (context, error) => {
  context.showToasterError(error);
  context.smallLoading = false;
  if (error && error.response && error.response.data && error.response.data.haveAttachedData) {
    context.showConfirmationModal();
  }
};

export default (context, data, rentalId) => {
  return Vue.$http.post(`rental/connect-booking/${rentalId}`, data)
    .then(response => {
      if (response && response.status === 200) {
        success(context, response);
      }
    }).catch(error => {
      failed(context, error);
    })
};



// WEBPACK FOOTER //
// ./src/app/services/rental/updateForward.js